function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import morphdom from 'morphdom';
import { shouldMorph, didMorph } from './morph_callbacks';
import { assignFocus, dispatch, getClassNames, processElements, before, after, operate } from './utils';
export default {
  // DOM Mutations
  append: function append(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var html = operation.html,
            focusSelector = operation.focusSelector;
        element.insertAdjacentHTML('beforeend', html || '');
        assignFocus(focusSelector);
      });
      after(element, operation);
    });
  },
  graft: function graft(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var parent = operation.parent,
            focusSelector = operation.focusSelector;
        var parentElement = document.querySelector(parent);

        if (parentElement) {
          parentElement.appendChild(element);
          assignFocus(focusSelector);
        }
      });
      after(element, operation);
    });
  },
  innerHtml: function innerHtml(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var html = operation.html,
            focusSelector = operation.focusSelector;
        element.innerHTML = html || '';
        assignFocus(focusSelector);
      });
      after(element, operation);
    });
  },
  insertAdjacentHtml: function insertAdjacentHtml(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var html = operation.html,
            position = operation.position,
            focusSelector = operation.focusSelector;
        element.insertAdjacentHTML(position || 'beforeend', html || '');
        assignFocus(focusSelector);
      });
      after(element, operation);
    });
  },
  insertAdjacentText: function insertAdjacentText(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var text = operation.text,
            position = operation.position,
            focusSelector = operation.focusSelector;
        element.insertAdjacentText(position || 'beforeend', text || '');
        assignFocus(focusSelector);
      });
      after(element, operation);
    });
  },
  morph: function morph(operation) {
    processElements(operation, function (element) {
      var html = operation.html;
      var template = document.createElement('template');
      template.innerHTML = String(html).trim();
      operation.content = template.content;
      var parent = element.parentElement;
      var ordinal = Array.from(parent.children).indexOf(element);
      before(element, operation);
      operate(operation, function () {
        var childrenOnly = operation.childrenOnly,
            focusSelector = operation.focusSelector;
        morphdom(element, childrenOnly ? template.content : template.innerHTML, {
          childrenOnly: !!childrenOnly,
          onBeforeElUpdated: shouldMorph(operation),
          onElUpdated: didMorph(operation)
        });
        assignFocus(focusSelector);
      });
      after(parent.children[ordinal], operation);
    });
  },
  outerHtml: function outerHtml(operation) {
    processElements(operation, function (element) {
      var parent = element.parentElement;
      var ordinal = Array.from(parent.children).indexOf(element);
      before(element, operation);
      operate(operation, function () {
        var html = operation.html,
            focusSelector = operation.focusSelector;
        element.outerHTML = html || '';
        assignFocus(focusSelector);
      });
      after(parent.children[ordinal], operation);
    });
  },
  prepend: function prepend(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var html = operation.html,
            focusSelector = operation.focusSelector;
        element.insertAdjacentHTML('afterbegin', html || '');
        assignFocus(focusSelector);
      });
      after(element, operation);
    });
  },
  remove: function remove(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var focusSelector = operation.focusSelector;
        element.remove();
        assignFocus(focusSelector);
      });
      after(document, operation);
    });
  },
  replace: function replace(operation) {
    processElements(operation, function (element) {
      var parent = element.parentElement;
      var ordinal = Array.from(parent.children).indexOf(element);
      before(element, operation);
      operate(operation, function () {
        var html = operation.html,
            focusSelector = operation.focusSelector;
        element.outerHTML = html || '';
        assignFocus(focusSelector);
      });
      after(parent.children[ordinal], operation);
    });
  },
  textContent: function textContent(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var text = operation.text,
            focusSelector = operation.focusSelector;
        element.textContent = text || '';
        assignFocus(focusSelector);
      });
      after(element, operation);
    });
  },
  // Element Property Mutations
  addCssClass: function addCssClass(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var _element$classList;

        var name = operation.name;

        (_element$classList = element.classList).add.apply(_element$classList, _toConsumableArray(getClassNames(name || '')));
      });
      after(element, operation);
    });
  },
  removeAttribute: function removeAttribute(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var name = operation.name;
        element.removeAttribute(name);
      });
      after(element, operation);
    });
  },
  removeCssClass: function removeCssClass(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var _element$classList2;

        var name = operation.name;

        (_element$classList2 = element.classList).remove.apply(_element$classList2, _toConsumableArray(getClassNames(name)));
      });
      after(element, operation);
    });
  },
  setAttribute: function setAttribute(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var name = operation.name,
            value = operation.value;
        element.setAttribute(name, value || '');
      });
      after(element, operation);
    });
  },
  setDatasetProperty: function setDatasetProperty(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var name = operation.name,
            value = operation.value;
        element.dataset[name] = value || '';
      });
      after(element, operation);
    });
  },
  setProperty: function setProperty(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var name = operation.name,
            value = operation.value;
        if (name in element) element[name] = value || '';
      });
      after(element, operation);
    });
  },
  setStyle: function setStyle(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var name = operation.name,
            value = operation.value;
        element.style[name] = value || '';
      });
      after(element, operation);
    });
  },
  setStyles: function setStyles(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var styles = operation.styles;

        for (var _i2 = 0, _Object$entries = Object.entries(styles); _i2 < _Object$entries.length; _i2++) {
          var _ref3 = _Object$entries[_i2];

          var _ref2 = _slicedToArray(_ref3, 2);

          var name = _ref2[0];
          var value = _ref2[1];
          element.style[name] = value || '';
        }
      });
      after(element, operation);
    });
  },
  setValue: function setValue(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var value = operation.value;
        element.value = value || '';
      });
      after(element, operation);
    });
  },
  // DOM Events
  dispatchEvent: function dispatchEvent(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var name = operation.name,
            detail = operation.detail;
        dispatch(element, name, detail);
      });
      after(element, operation);
    });
  },
  setMeta: function setMeta(operation) {
    before(document, operation);
    operate(operation, function () {
      var name = operation.name,
          content = operation.content;
      var meta = document.head.querySelector("meta[name='".concat(name, "']"));

      if (!meta) {
        meta = document.createElement('meta');
        meta.name = name;
        document.head.appendChild(meta);
      }

      meta.content = content;
    });
    after(document, operation);
  },
  // Browser Manipulations
  clearStorage: function clearStorage(operation) {
    before(document, operation);
    operate(operation, function () {
      var type = operation.type;
      var storage = type === 'session' ? sessionStorage : localStorage;
      storage.clear();
    });
    after(document, operation);
  },
  go: function go(operation) {
    before(window, operation);
    operate(operation, function () {
      var delta = operation.delta;
      history.go(delta);
    });
    after(window, operation);
  },
  pushState: function pushState(operation) {
    before(window, operation);
    operate(operation, function () {
      var state = operation.state,
          title = operation.title,
          url = operation.url;
      history.pushState(state || {}, title || '', url);
    });
    after(window, operation);
  },
  redirectTo: function redirectTo(operation) {
    before(window, operation);
    operate(operation, function () {
      var url = operation.url,
          action = operation.action;
      action = action || 'advance';
      if (window.Turbo) window.Turbo.visit(url, {
        action: action
      });
      if (window.Turbolinks) window.Turbolinks.visit(url, {
        action: action
      });
      if (!window.Turbo && !window.Turbolinks) window.location.href = url;
    });
    after(window, operation);
  },
  reload: function reload(operation) {
    before(window, operation);
    operate(operation, function () {
      window.location.reload();
    });
    after(window, operation);
  },
  removeStorageItem: function removeStorageItem(operation) {
    before(document, operation);
    operate(operation, function () {
      var key = operation.key,
          type = operation.type;
      var storage = type === 'session' ? sessionStorage : localStorage;
      storage.removeItem(key);
    });
    after(document, operation);
  },
  replaceState: function replaceState(operation) {
    before(window, operation);
    operate(operation, function () {
      var state = operation.state,
          title = operation.title,
          url = operation.url;
      history.replaceState(state || {}, title || '', url);
    });
    after(window, operation);
  },
  scrollIntoView: function scrollIntoView(operation) {
    var element = operation.element;
    before(element, operation);
    operate(operation, function () {
      element.scrollIntoView(operation);
    });
    after(element, operation);
  },
  setCookie: function setCookie(operation) {
    before(document, operation);
    operate(operation, function () {
      var cookie = operation.cookie;
      document.cookie = cookie || '';
    });
    after(document, operation);
  },
  setFocus: function setFocus(operation) {
    var element = operation.element;
    before(element, operation);
    operate(operation, function () {
      assignFocus(element);
    });
    after(element, operation);
  },
  setStorageItem: function setStorageItem(operation) {
    before(document, operation);
    operate(operation, function () {
      var key = operation.key,
          value = operation.value,
          type = operation.type;
      var storage = type === 'session' ? sessionStorage : localStorage;
      storage.setItem(key, value || '');
    });
    after(document, operation);
  },
  // Notifications
  consoleLog: function consoleLog(operation) {
    before(document, operation);
    operate(operation, function () {
      var message = operation.message,
          level = operation.level;
      level && ['warn', 'info', 'error'].includes(level) ? console[level](message || '') : console.log(message || '');
    });
    after(document, operation);
  },
  consoleTable: function consoleTable(operation) {
    before(document, operation);
    operate(operation, function () {
      var data = operation.data,
          columns = operation.columns;
      console.table(data, columns || []);
    });
    after(document, operation);
  },
  notification: function notification(operation) {
    before(document, operation);
    operate(operation, function () {
      var title = operation.title,
          options = operation.options;
      Notification.requestPermission().then(function (result) {
        operation.permission = result;
        if (result === 'granted') new Notification(title || '', options);
      });
    });
    after(document, operation);
  }
};